import { render, staticRenderFns } from "./abouauthor.vue?vue&type=template&id=c044085a&scoped=true&"
import script from "./abouauthor.vue?vue&type=script&lang=js&"
export * from "./abouauthor.vue?vue&type=script&lang=js&"
import style0 from "./abouauthor.vue?vue&type=style&index=0&id=c044085a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c044085a",
  null
  
)

export default component.exports